import * as React from 'react';
import MediaRecordingActions from "./actions/MediaRecordingActions";

export function withActions(WrappedComponent) {

  return class extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        actions: new MediaRecordingActions()
      };
    }

    render() {
      return <WrappedComponent actions={this.state.actions} {...this.props} />;
    }
  };
}